<ngx-spinner [name]="appSpinner" bdColor="rgba(0, 0, 0, 0)" size="medium" color="#03a9f4" type="square-jelly-box" [fullScreen]="true"><p style="color: white"></p></ngx-spinner>
<router-outlet></router-outlet>